import { AlertType } from "@tandemdiabetes/sugarmate-api-react-client"

import {
  Contacts,
  PhoneNumber,
  SetupHelpLink,
} from "../Contacts"
import styles from "./SMSAlerts.module.scss"
import { UrgentLowThreshold } from "./UrgentLowThreshold"
import { UrgentLowToggle } from "./UrgentLowToggle"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useAlert,
  useDebouncedUpdateAlert,
  usePrimaryPhone,
} from "src/hooks"

export function SMSAlerts() {
  const polyglot = usePolyglot()
  const primaryPhone = usePrimaryPhone()
  const urgentLowSMS = useAlert(AlertType.UrgentLowSMS)

  const {
    currentUserId,
    currentFollow,
  } = useFollowedUsers()

  const debouncedUpdatePartialAlert = useDebouncedUpdateAlert(
    primaryPhone,
    urgentLowSMS,
    "sms-alerts-update-error-toast",
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.sms")}
      backRoutePath={currentFollow.is_self ? "/settings/alerts" : "/settings/alerts/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        {urgentLowSMS && (
          <UrgentLowToggle
            urgentLowSMS={urgentLowSMS}
            updateAlert={debouncedUpdatePartialAlert}
          />
        )}
        {urgentLowSMS?.is_active && (
          <>
            <UrgentLowThreshold
              urgentLowSMS={urgentLowSMS}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <PhoneNumber
              primaryPhone={primaryPhone}
              maxPhoneNumbers={5}
              sugarmateAlert={urgentLowSMS}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <Contacts
              primaryPhone={primaryPhone}
              sugarmateAlert={urgentLowSMS}
            />
            <SetupHelpLink />
          </>
        )}
      </div>
    </PageTemplate>
  )
}
